import {GoDotFill} from "react-icons/go";
import useTranslate from "../../modules/local/useTranslate";
import classNames from "classnames";
import React from "react";
import {renderIf} from "../../views/Shared";


export const ItemInfoGrid = ({showIcon = false, center = false, label, value, className = 'text-base italic', primary = false}) => {
    const t = useTranslate()
    return (
        <div className={classNames('grid grid-cols-1 md:grid-cols-2 gap-x-1', className)}>
          <span className={classNames("text-color-400 whitespace-no-wrap italic", center === true && 'text-right')}>
              {renderIf(
                  showIcon === true,
                  <GoDotFill size={10} className="text-color-400 mr-1"/>
              )}
              {`${t(label)}: `}
          </span>
            <span
                className={primary === true ? 'font-bold text-gray-800' : value ? 'font-semibold text-color-100' : 'text-color-300 italic'}>
              {value ? value : t('not update')}
          </span>
        </div>
    )
}
